import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { handleOnKeyDown } from 'src/utils/Form'
import { selectDataToExecuteInventory, selectDataPosition, selectGoToTableInventories } from '../../InventorySelector'
import { actions } from '../../InventoryState'
import { TableInventoriesToExecute } from '../TableInventoriesToExecute/TableInventoriesToExecute'
import * as S from './UnlinkOperator.styles'
import { fixInputSx } from '../../utils'

interface Props {
    setClickUnlinkOperator: (value: boolean) => void
}

export const UnlinkOperator = ({ setClickUnlinkOperator }: Props) => {
  const dispatch = useDispatch()
  const { badge } = useSelector(selectDataToExecuteInventory)
  const position = useSelector(selectDataPosition)
  const goToTableInventories = useSelector(selectGoToTableInventories)

  const [, setInitialState] = useState(false)

  const {
    register, getValues, setError, formState: { errors },
  } = useForm()

  const unlinkOperator = () => {
    const badgeSupervisor = getValues('badgeSupervisor')

    if (!badgeSupervisor) {
      setError('badgeSupervisor', { message: 'Campo obrigatório' })
      return
    }

    dispatch(actions.unlinkOperator({
      idPosition: position.idPosition,
      badge,
      badgeSupervisor,
      setError: (message) => setError('badge', { message }),
    }))
  }

  if (goToTableInventories === true) return <TableInventoriesToExecute setInitialState={setInitialState}/>

  return (
    <S.Wrapper>
      <h6>Crachá do fiscal para confirmar desvinculação</h6>
      <S.CustomTextWrapper>
        <S.CustomTextField
          sx={{ ...fixInputSx }}
          id='badgeSupervisor'
          name='badgeSupervisor'
          type='password'
          autoComplete='off'
          inputProps={{ ...register('badgeSupervisor', { required: 'Campo obrigatório' }), 'data-testid': 'badge-test' }}
          error={!!errors.badgeSupervisor}
          label='badge'
          helperText={errors.badgeSupervisor?.message}
          fullWidth
          size='medium'
          data-testid='badge-input-test'
          onKeyDown={(e) => handleOnKeyDown(e, '', unlinkOperator)}
        />
      </S.CustomTextWrapper>
      <S.ContainerButton>
        <S.CustomButton
          title='confirmar desvinculação'
          bgColor='confirm'
          hoverColor='confirmHover'
          letterColor='white'
          onClick={() => unlinkOperator()}
          data-testid='confirm-unlink-operator-test'
        />
        <S.CustomButton
          title='Voltar'
          type='submit'
          bgColor='blue'
          hoverColor='darkBlueHover'
          letterColor='white'
          onClick={() => setClickUnlinkOperator(false)}
        />
      </S.ContainerButton>
    </S.Wrapper>
  )
}
